export default [
  {
    id: "1",
    question: "Do we require coding skills for the event?",
    answer:
      "It's about how well you do in high-order thinking, and whether you're good at puzzles and riddles. So nope, coding skills are not required.",
  },
  {
    id: "2",
    question: "How many members can we have per team?",
    answer:
      "You can have up to six members in a team, but it's not necessary to have a team, as you can also compete individually.",
  },
  {
    id: "3",
    question: "When will the event be held?",
    answer:
      "The event will be held on two days, 23rd September 2023 and 24th September 2023.",
  },
  {
    id: "4",
    question: "Will refreshments be provided?",
    answer:
      "There will be many stalls in and around the campus, and you can always go outside to the restraunts around VIT.",
  },
  {
    id: "5",
    question: "Is the event going to have a participating fee?",
    answer:
      "The Hybrid Cryptic Hunt has a participation fee of ₹200 per person for the entire two-day event.",
  },
  {
    id: "6",
    question: "Will the event be conducted online or offline?",
    answer: "The event will be conducted offline through our app.",
  },
  {
    id: "7",
    question: "Can we switch teams?",
    answer:
      "Yes, but once the teams are finalized and the event begins, it wouldn't be possible.",
  },
  {
    id: "8",
    question: "Who can participate?",
    answer:
      "Anyone from amateurs to professional mavens can participate in this event.",
  },
];
